import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UserAddOutlined, UserOutlined, CrownOutlined, CloseOutlined, MenuOutlined, HeartOutlined } from '@ant-design/icons';
import { useSponsor } from '../context/SponsorContext';

const LandingNavbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const { sponsorData } = useSponsor();
    const partnerEnabled = sponsorData?.enabled && sponsorData?.official_partner;
    const partner = sponsorData?.official_partner;

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Lock body scroll when sidebar is open
    useEffect(() => {
        document.body.style.overflow = sidebarOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [sidebarOpen]);

    const close = () => setSidebarOpen(false);

    const navBtnBase = {
        display: 'inline-flex', alignItems: 'center', gap: '7px',
        borderRadius: '10px', padding: '8px 20px',
        fontSize: '0.88rem', fontWeight: '600', cursor: 'pointer',
        transition: 'all 0.25s cubic-bezier(0.4,0,0.2,1)',
        textDecoration: 'none', whiteSpace: 'nowrap', border: 'none',
    };

    return (
        <>
            {/* ── Top Navbar ── */}
            <nav style={{
                position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
                backgroundColor: scrolled ? 'rgba(255,255,255,0.96)' : 'rgba(173,20,87,0.97)',
                backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
                padding: isMobile ? '0.55rem 20px' : '0.55rem 60px',
                fontFamily: 'Calibri, sans-serif',
                transition: 'all 0.35s cubic-bezier(0.4,0,0.2,1)',
                boxShadow: scrolled ? '0 2px 20px rgba(173,20,87,0.12)' : '0 2px 16px rgba(0,0,0,0.08)',
                borderBottom: scrolled ? '1px solid rgba(173,20,87,0.08)' : 'none',
            }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {/* Brand */}
                <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/oottan_com_white_background.png`}
                        alt="Oottan"
                        style={{ height: '44px', width: 'auto', objectFit: 'contain' }}
                    />
                </Link>

                {/* Desktop — sponsor + nav buttons */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} className="d-none d-lg-flex">
                    {/* Sponsor logo — desktop */}
                    {partnerEnabled && (
                        <a
                            href={partner.website_url}
                            target="_blank" rel="noreferrer"
                            style={{
                                display: 'flex', flexDirection: 'column', alignItems: 'center',
                                justifyContent: 'center', textDecoration: 'none',
                                padding: '4px 16px', marginRight: '8px',
                                borderLeft: scrolled ? '1px solid rgba(173,20,87,0.12)' : '1px solid rgba(255,255,255,0.2)',
                                borderRight: scrolled ? '1px solid rgba(173,20,87,0.12)' : '1px solid rgba(255,255,255,0.2)',
                            }}
                        >
                            <div style={{
                                fontSize: '0.58rem', fontWeight: '600', letterSpacing: '0.5px',
                                textTransform: 'uppercase', marginBottom: '3px',
                                color: scrolled ? 'rgba(173,20,87,0.6)' : 'rgba(255,255,255,0.8)',
                                transition: 'color 0.35s ease',
                            }}>
                                {partner.label || 'Official Partner'}
                            </div>
                            <div style={{ background: 'white', borderRadius: '6px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img
                                    src={partner.logo_url}
                                    alt={partner.name}
                                    style={{ height: '22px', maxWidth: '100px', width: 'auto', objectFit: 'contain', display: 'block' }}
                                />
                            </div>
                        </a>
                    )}

                    <Link to="/signup" style={{ ...navBtnBase, background: scrolled ? 'linear-gradient(135deg,#AD1457,#D81B60)' : 'white', color: scrolled ? 'white' : '#AD1457', boxShadow: scrolled ? '0 4px 16px rgba(173,20,87,0.32)' : '0 2px 10px rgba(0,0,0,0.1)' }}
                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = scrolled ? '0 6px 20px rgba(173,20,87,0.45)' : '0 4px 16px rgba(0,0,0,0.15)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = scrolled ? '0 4px 16px rgba(173,20,87,0.32)' : '0 2px 10px rgba(0,0,0,0.1)'; }}>
                        <UserAddOutlined /> Create Account
                    </Link>

                    <Link to="/login" style={{ ...navBtnBase, background: 'transparent', color: scrolled ? '#AD1457' : 'rgba(255,255,255,0.92)', border: scrolled ? '1.5px solid rgba(173,20,87,0.4)' : '1.5px solid rgba(255,255,255,0.5)' }}
                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.background = scrolled ? 'rgba(173,20,87,0.06)' : 'rgba(255,255,255,0.12)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.background = 'transparent'; }}>
                        <UserOutlined /> Sign In
                    </Link>

                    <Link to="/pricing" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        style={{ ...navBtnBase, background: 'linear-gradient(135deg,#F59E0B,#FCD34D)', color: '#78350F', boxShadow: '0 4px 16px rgba(245,158,11,0.3)', fontWeight: '700' }}
                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(245,158,11,0.45)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(245,158,11,0.3)'; }}>
                        <CrownOutlined /> Premium
                    </Link>
                </div>

                {/* Mobile — hamburger */}
                <button
                    className="d-lg-none"
                    onClick={() => setSidebarOpen(true)}
                    style={{
                        background: 'none', border: 'none', cursor: 'pointer', padding: '6px',
                        color: scrolled ? '#AD1457' : 'white', fontSize: '1.4rem',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}
                >
                    <MenuOutlined />
                </button>
                </div>
            </nav>

            {/* ── Backdrop ── */}
            <div
                onClick={close}
                style={{
                    position: 'fixed', inset: 0, zIndex: 1100,
                    background: 'rgba(0,0,0,0.45)',
                    backdropFilter: 'blur(3px)',
                    opacity: sidebarOpen ? 1 : 0,
                    pointerEvents: sidebarOpen ? 'auto' : 'none',
                    transition: 'opacity 0.3s ease',
                }}
            />

            {/* ── Sidebar Drawer ── */}
            <div style={{
                position: 'fixed', top: 0, right: 0, bottom: 0, zIndex: 1200,
                width: '280px',
                background: 'linear-gradient(180deg, #880E6E 0%, #AD1457 50%, #D81B60 100%)',
                boxShadow: '-8px 0 40px rgba(0,0,0,0.3)',
                transform: sidebarOpen ? 'translateX(0)' : 'translateX(100%)',
                transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1)',
                display: 'flex', flexDirection: 'column',
                fontFamily: 'Calibri, sans-serif',
                overflowY: 'auto',
            }}>
                {/* Sidebar header */}
                <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '20px 24px',
                    borderBottom: '1px solid rgba(255,255,255,0.12)',
                }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/oottan_com_white_background.png`}
                        alt="Oottan"
                        style={{ height: '38px', width: 'auto', objectFit: 'contain' }}
                    />
                    <button onClick={close} style={{
                        background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)',
                        borderRadius: '8px', width: '34px', height: '34px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'pointer', color: 'white', fontSize: '0.95rem',
                    }}>
                        <CloseOutlined />
                    </button>
                </div>

                {/* Nav links */}
                <div style={{ padding: '24px 20px', display: 'flex', flexDirection: 'column', gap: '10px', flex: 1 }}>
                    <Link to="/signup" onClick={close} style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        padding: '14px 18px', borderRadius: '12px', textDecoration: 'none',
                        background: 'white', color: '#AD1457',
                        fontWeight: '700', fontSize: '1rem',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                    }}>
                        <UserAddOutlined style={{ fontSize: '1.1rem' }} />
                        Create Account
                    </Link>

                    <Link to="/login" onClick={close} style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        padding: '14px 18px', borderRadius: '12px', textDecoration: 'none',
                        background: 'rgba(255,255,255,0.12)',
                        border: '1px solid rgba(255,255,255,0.25)',
                        color: 'white', fontWeight: '600', fontSize: '1rem',
                    }}>
                        <UserOutlined style={{ fontSize: '1.1rem' }} />
                        Sign In
                    </Link>

                    <Link to="/pricing" onClick={close} style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        padding: '14px 18px', borderRadius: '12px', textDecoration: 'none',
                        background: 'linear-gradient(135deg,#F59E0B,#FCD34D)',
                        color: '#78350F', fontWeight: '700', fontSize: '1rem',
                        boxShadow: '0 4px 16px rgba(245,158,11,0.35)',
                    }}>
                        <CrownOutlined style={{ fontSize: '1.1rem' }} />
                        Premium Plans
                    </Link>

                    <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', margin: '6px 0' }} />

                    <Link to="/message-from-ceo" onClick={close} style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        padding: '12px 18px', borderRadius: '12px', textDecoration: 'none',
                        color: 'rgba(255,255,255,0.85)', fontWeight: '500', fontSize: '0.95rem',
                    }}>
                        <HeartOutlined style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.6)' }} />
                        Message from CEO
                    </Link>

                    <Link to="/contact-us" onClick={close} style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        padding: '12px 18px', borderRadius: '12px', textDecoration: 'none',
                        color: 'rgba(255,255,255,0.85)', fontWeight: '500', fontSize: '0.95rem',
                    }}>
                        <UserOutlined style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.6)' }} />
                        Contact Us
                    </Link>
                </div>

                {/* Sponsor logo at bottom — mobile sidebar */}
                {partnerEnabled && (
                    <div style={{
                        padding: '16px 24px 28px',
                        borderTop: '1px solid rgba(255,255,255,0.12)',
                        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
                    }}>
                        <div style={{ fontSize: '0.6rem', fontWeight: '600', letterSpacing: '0.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)' }}>
                            {partner.label || 'Official Partner'}
                        </div>
                        <a href={partner.website_url} target="_blank" rel="noreferrer"
                            style={{ background: 'white', borderRadius: '8px', padding: '0', display: 'flex', alignItems: 'center' }}>
                            <img
                                src={partner.logo_url}
                                alt={partner.name}
                                style={{ height: '24px', width: 'auto', objectFit: 'contain', display: 'block' }}
                            />
                        </a>
                    </div>
                )}
            </div>
        </>
    );
};

export default LandingNavbar;
